import '@fontsource-variable/open-sans';
import { Theme, ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { FC, PropsWithChildren } from 'react';

const theme: Theme = createTheme({
  palette: {
    primary: {
      contrastText: '#fff',
      main: '#004A98',
      light: '#195ca2',
      dark: '#14284D'
    },
    secondary: {
      contrastText: '#000',
      main: '#b9901d'
    },
    background: {
      default: '#f7f7f7',
      paper: '#e4e4e4'
    },
    divider: '#9e9e9e',
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121'
    },
    info: {
      main: 'rgba(0,0,0,0.6)',
      dark: 'rgba(0,0,0,0.87)'
    }
  },
  typography: {
    fontFamily: 'stolzl, poppins, sans-serif'
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: 'stolzl, poppins, sans-serif'
        }
      }
    }
  }
});

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => (
  <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
);
